export const namespaced = true;
const defaultData = {
    products: {}
}
export const state = () => (defaultData);

export const getters = {
    getProducts: state => state.products,
}

export const mutations = {
    mutateProducts(state, products) {
        state.products = products
    }
};

export const actions = {
    setProducts({commit}, products) {
        return new Promise((resolve, reject) => {
            commit('mutateProducts', products);
            resolve()
        })
    }
};

